// 渠道分销商品
export const C_DIS_GOODS = 'C_DIS_GOODS'

// 渠道自主商品
export const C_NORMAL_GOODS = 'C_NORMAL_GOODS'

// 渠道自主商品-按SKU列表
export const C_NORMAL_GOODS_SKU = 'C_NORMAL_GOODS_SKU'

// 渠道自主商品-按组合装列表
export const C_NORMAL_GOODS_COMBINE = 'C_NORMAL_GOODS_COMBINE'

// 渠道店铺管理
export const C_SHOP = 'C_SHOP'

// 渠道代发订单
export const C_DIS_ORDER = 'C_DIS_ORDER'

// 渠道自发订单
export const C_NORMAL_ORDER = 'C_NORMAL_ORDER'

// 渠道未结算订单
export const C_UN_STATEMENT_ORDER = 'C_UN_STATEMENT_ORDER'

// 渠道未结算订单
export const C_STATEMENT_ORDER = 'C_STATEMENT_ORDER'

// 渠道我的供应商
export const C_MY_SUPPLIER = 'C_MY_SUPPLIER'

// 渠道侧供应商价格及库存
export const C_SUPPLIER_STOCK = 'C_SUPPLIER_STOCK'

// 渠道侧分销资金明细
export const C_FUNDS = 'C_FUNDS'

// 渠道侧分销资金明细-供应商
export const C_FUNDS_SUPPLIER = 'C_FUNDS_SUPPLIER'

// 渠道侧用户管理
export const C_USER = 'C_USER'

// 渠道侧售后管理
export const C_AFTERSALES_MANAGE = 'C_AFTERSALES_MANAGE'

// 渠道侧分销商的售后单
export const C_AFTERSALES_DISTRIBUTE_MANAGE = 'C_AFTERSALES_DISTRIBUTE_MANAGE'

// 渠道侧分销账户管理-我的分销商
export const C_DISACCOUNT_CHANNEL = 'C_DISACCOUNT_CHANNEL_1'

// 渠道侧分销账户管理-我的供应商
export const C_DISACCOUNT_SUPPLIER = 'C_DISACCOUNT_SUPPLIER'

// 供应侧首页
export const S_DASHBOARD = 'S_DASHBOARD'

// 供应侧商品管理(极速)
export const S_GOODS_SPEED = 'S_GOODS_SPEED'

// 供应侧商品管理
export const S_GOODS = 'S_GOODS'

// 供应侧供销商品
export const S_MARKETING = 'S_MARKETING'

// 供应侧分销商品
export const S_DIS_GOODS = 'S_DIS_GOODS'

// 供应侧分销商品
export const S_DIS_GOODS_SKU = 'S_DIS_GOODS_SKU'

// 供应侧供应侧分销组合装商品
export const S_DIS_GOODS_COMBINE = 'S_DIS_GOODS_COMBINE'

// 供应侧店铺管理
export const S_SHOP = 'S_SHOP'

// 供应侧我的分销商
export const S_MY_DISTRIBUTOR = 'S_MY_DISTRIBUTOR'

// 供应侧我的供应商
export const S_MY_SUPPLIER = 'S_MY_SUPPLIER'

// 供应侧分销资金明细
export const S_FUNDS = 'S_FUNDS'

// 供应侧分销资金明细-供应商
export const S_FUNDS_SUPPLIER = 'S_FUNDS_SUPPLIER'

// 供应侧分销资金明细-分销商
export const S_FUNDS_CHANNEL = 'S_FUNDS_CHANNEL'

// 供应侧采购代发订单
export const S_PURCHASE_DIS_ORDER = 'S_PURCHASE_DIS_ORDER'

// 供应侧普通订单
export const S_NORMAL_ORDER = 'S_NORMAL_ORDER'

// 供应侧未结算订单
export const S_UN_STATEMENT_ORDER = 'S_UN_STATEMENT_ORDER'

// 供应侧已结算订单
export const S_STATEMENT_ORDER = 'S_STATEMENT_ORDER'

// 供应侧用户管理
export const S_USER = 'S_USER'

// 供应侧商品管理(极速)-按SKU列表
export const S_GOODS_SPEED_SKU = 'S_GOODS_SPEED_SKU'

// 供应侧商品管理(极速)-按SKU列表
export const S_GOODS_DISTRIBUTMANAGE_SKU = 'S_GOODS_DISTRIBUTMANAGE_SKU'

// 供应侧供应商价格及库存
export const S_SUPPLIER_STOCK = 'S_SUPPLIER_STOCK'

// 供应侧售后管理
export const S_AFTERSALES_MANAGE = 'S_AFTERSALES_MANAGE'

// 供应侧分销商的售后单
export const S_AFTERSALES_DISTRIBUTE_MANAGE = 'S_AFTERSALES_DISTRIBUTE_MANAGE'

// 供应侧我的分销商
export const S_MY_PARTNER = 'S_MY_PARTNER'

// 供应侧分销账户管理-我的分销商
export const S_DISACCOUNT_CHANNEL = 'S_DISACCOUNT_CHANNEL_1'

// 供应侧分销账户管理-我的供应商
export const S_DISACCOUNT_SUPPLIER = 'S_DISACCOUNT_SUPPLIER'

// 供应侧/渠道侧商品运营分析
export const S_C_OPERATE_ANALYSIS_SPU = 'S_C_OPERATE_ANALYSIS_SPU'

// 供应侧/渠道侧商品运营分析
export const S_C_OPERATE_ANALYSIS_SKU = 'S_C_OPERATE_ANALYSIS_SKU'

// 供应侧/渠道侧商品运营分析[按链接]
export const S_C_OPERATE_ANALYSIS_SHOP = 'S_C_OPERATE_ANALYSIS_SHOP'

// 供应侧/渠道侧商品运营分析按链接分析-看SKU明细列表
export const S_C_OPERATE_ANALYSIS_SHOP_ITEM_DETAILS = 'S_C_OPERATE_ANALYSIS_SHOP_ITEM_DETAILS'

// 中台选分销商列表
export const O_P_SELECT_CHANNEL = 'O_P_SELECT_CHANNEL'

// 中台选支付预警列表
export const O_P_PAY_RISK_LIST = 'O_P_PAY_RISK_LIST'

// 中台 寻合作配置，选商家
export const O_P_SELECT_COMPANY = 'O_P_SELECT_COMPANY'

// 中台 寻合作配置，选商品
export const O_P_SELECT_GOODS = 'O_P_SELECT_GOODS'

// 中台 寻合作配置，选商品 供应商视图
export const O_P_SELECT_GOODS_SUPPLIER = 'O_P_SELECT_GOODS_SUPPLIER'

// 中台 寻合作配置，选类目
export const O_P_SELECT_CATEGORY = 'O_P_SELECT_CATEGORY'

// 中台 寻合作配置，爆款专区
export const O_P_HOT_ZONE = 'O_P_HOT_ZONE'

// 中台 寻合作配置，爆款专区类目分析
export const O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV1 = 'O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV1'
export const O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV2 = 'O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV2'
export const O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV3 = 'O_P_HOT_ZONE_CATEGORY_ANALYSIS_LV3'

// 出账结算抽屉表格-商品信息列设置key
export const S_PAYMENT_SETTLEMENT_COLUMN = 'C_PAYMENT_SETTLEMENT_COLUMN_NEW'

// 出账结算明细表格-商品信息列设置key
export const S_SETTLEMENT_DETAIL_COLUMN = 'S_SETTLEMENT_DETAIL_COLUMN'

// 供应侧/渠道侧 创建售后单 goodTable
export const S_C_CREATE_AFTERSALE_ORDER_GOODSTABLE = 'S_C_CREATE_AFTERSALE_ORDER_GOODSTABLE'
// 供应侧/渠道侧 创建售后单 orderTable
export const S_C_CREATE_AFTERSALE_ORDER_TABLE = 'S_C_CREATE_AFTERSALE_ORDER_TABLE'

// 供应侧/渠道侧结算列表
export const S_C_SETTLEMENT_LIST = 'S_C_SETTLEMENT_LIST'

// 供应侧分销客户中心已合作列表
export const S_DIS_ACCOUNT_CENTER_LIST = 'S_DIS_ACCOUNT_CENTER_LIST'

// 供应侧分销客户中心未合作列表
export const S_DIS_ACCOUNT_CENTER_LIST_UN_COOP = 'S_DIS_ACCOUNT_CENTER_LIST_UN_COOP'

// 中台 在线收付款管理/退款单明细
export const O_P_REFUND_LIST = 'O_P_REFUND_LIST'

// 中台 商家网商账户
export const O_P_MERCHANT_ACCOUNT_LIST = 'O_P_MERCHANT_ACCOUNT_LIST'

// 售后管理-商品信息弹框-列表
export const AFTERSALES_GOODSINFO_TABLE_COLUMN = 'AFTERSALES_GOODSINFO_TABLE_COLUMN_3'

// 合作供应商分析列表
export const S_C_SUPPLIER_ANALYSIS_LIST = 'S_C_SUPPLIER_ANALYSIS_LIST'

// 供应侧商品管理-店铺商品-按SKU列表
export const S_GOODS_ONLINE_STORE_SKU = 'S_GOODS_ONLINE_STORE_SKU'
// 渠道侧商品管理-店铺商品-按SKU列表
export const C_NORMAL_ONLINE_STORE_SKU = 'C_NORMAL_ONLINE_STORE_SKU'
// 供应侧商品管理-店铺商品-按款式列表
export const S_GOODS_ONLINE_STORE_STYLE = 'S_GOODS_ONLINE_STORE_STYLE'
// 渠道侧商品管理-店铺商品-按款式列表
export const C_NORMAL_ONLINE_STORE_STYLE = 'C_NORMAL_ONLINE_STORE_STYLE'

/** 达人管理-公司达人列表-抖音 */
export const DAREN_MGR_COMPANY_DAREN_DY = 'DAREN_MGR_COMPANY_DAREN_DY'
/** 达人管理-公司达人列表-快手 */
export const DAREN_MGR_COMPANY_DAREN_KS = 'DAREN_MGR_COMPANY_DAREN_KS'
/** 达人管理-公司达人列表-小红书 */
export const DAREN_MGR_COMPANY_DAREN_XHS = 'DAREN_MGR_COMPANY_DAREN_XHS'
/** 达人管理-公司达人列表-微信视频号 */
export const DAREN_MGR_COMPANY_DAREN_WX = 'DAREN_MGR_COMPANY_DAREN_WX'
/** 达人管理-我的达人列表-抖音 */
export const DAREN_MGR_MY_DAREN_DY = 'DAREN_MGR_MY_DAREN_DY'
/** 达人管理-我的达人列表-快手 */
export const DAREN_MGR_MY_DAREN_KS = 'DAREN_MGR_MY_DAREN_KS'
/** 达人管理-我的达人列表-小红书 */
export const DAREN_MGR_MY_DAREN_XHS = 'DAREN_MGR_MY_DAREN_XHS'
/** 达人管理-我的达人列表-微信视频号 */
export const DAREN_MGR_MY_DAREN_WX = 'DAREN_MGR_MY_DAREN_WX'
